export default "__VITE_ASSET__BhNJm4Qc__"